import RestHeader from "../components/RestHeader"
import Footer from "../components/Footer"
import { Outlet } from "react-router"

export default function SecondaryHome(){

    return(
        <>
        <RestHeader></RestHeader>
        <Outlet></Outlet>
        <Footer></Footer>
        </>
    )
}